import type { FC } from "react";

import { useNameFromPageAccessId } from "../helpers";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

type InstructorEditingStudentDraftBannerProps = {
  accessId: string;
  pageId: string;
};

export const InstructorEditingStudentDraftBanner: FC<InstructorEditingStudentDraftBannerProps> = ({
  accessId,
  pageId,
}) => {
  const studentOrGroupName = useNameFromPageAccessId(accessId, pageId);
  if (!studentOrGroupName) {
    return null;
  }

  return (
    <Banner className="page-block-width" kind="warning">
      {t("warning.editing_student_workspace", { name: studentOrGroupName })}
    </Banner>
  );
};
